import { MAPBOX_KEY } from 'constants/envVars';
import axios from 'axios';

export const searchMapBox =
	({ searchTerm, long, lat }) =>
	async dispatch => {
		let url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
			searchTerm
		)}.json?access_token=${MAPBOX_KEY}`;
		if (lat && long) {
			url = url.concat(`&proximity=${long},${lat}`);
		}
		try {
			const response = await axios.get(url);
			return response.data;
		} catch (errors) {
			console.error('errors', errors);
		}
	};
